

















import Vue from 'vue'

export default Vue.extend({
  props: {
    tagValue: {
      type: String,
      required: false,
      default: ''
    }
  },
  data(): {
    sortOrderItems: string
  } {
    return {
      sortOrderItems: ''
    }
  },
  methods: {}
})
